<script lang="ts">
	import {
		STARTER_DAILY_CANVAS_IMAGES,
		STARTER_DAILY_MATERIALS,
		STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES
	} from '$lib/constants';

	export let planName: 'Starter' | 'Plus' | 'Professional' | 'Team' | 'Organization' = 'Starter';
	export let checkmarkColor: string = 'text-zinc-200';
</script>

<div class="text-[13px]">
	{#if planName === 'Starter'}
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms text-zinc-500`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">
				{STARTER_DAILY_CANVAS_IMAGES} Texture Canvas generations daily.
			</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms text-zinc-500`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">
				{STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES} Reference to Texture generations daily.
			</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms text-zinc-500`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">
				{STARTER_DAILY_MATERIALS} Material Generator generations daily.
			</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms text-zinc-500`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">Creations may be shown anonymously in a public gallery.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms text-zinc-500`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">Personal/non-commercial license.</div>
		</div>
		<!-- <div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle text-sms text-zinc-800 opacity-50`}></i>
			<div class="w-4"></div>
			<div
				class="w-28 h-1 flex flex-row justify-center items-center bg-zinc-800 rounded opacity-50"
			>
			</div>
		</div> -->
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		></div>
	{/if}

	{#if planName === 'Plus'}
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">Generate as many textures and materials as you want.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Creations are fully private.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit text-left">Commercial use license.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		></div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		></div>
	{/if}

	{#if planName === 'Team'}
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Unlimited generations.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Everything in Pro.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Create custom presets.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Direct Slack/Discord support.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">NDA available on request.</div>
		</div>
		<div
			class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-fit">Includes 3 users.</div>
		</div>
	{/if}

	{#if planName === 'Professional'}
		<div
			class="w-48 h-11 flex flex-row justify-center items-center text-zinc-900 dark:text-zinc-300 text-xs text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-32">Unlimited image generations.</div>
		</div>
		<div
			class="w-48 h-11 flex flex-row justify-center items-center text-zinc-900 dark:text-zinc-300 text-xs text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-32">Unlimited 3D generations.</div>
		</div>
		<div
			class="w-48 h-11 flex flex-row justify-center items-center text-zinc-900 dark:text-zinc-300 text-xs text-center"
		>
			<i class={`fa-solid fa-circle-check text-sms ${checkmarkColor}`}></i>
			<div class="w-4"></div>
			<div class="w-32">Private by default.</div>
		</div>
	{/if}
</div>
